import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ServerUrl } from '../../../../../api/ServerUrl';
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const TestimoniulEdit = () => {
    const { http } = ProtectAPi();
    const { id } = useParams();
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [review, setReview] = useState('');
    const [image, setImage] = useState(null);
    const [testStatus, setTestStatus] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [loader, setLoader] = useState('off');
    const [nameError, setNameError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [reviewError, setReviewError] = useState('');

    useEffect(() => {
        http.get(`/get-single-testimoniul/${id}`)
            .then(res => {
                setName(res.data.name);
                setTitle(res.data.title);
                setReview(res.data.review);
                setTestStatus(res.data.status);
                if (res.data.image) {
                    setImagePreview(`${ServerUrl}/backend/img/testimoniul/${res.data.image}`);
                }
            })
            .catch(error => {
                console.error('Error fetching testimonial:', error);
            });
    }, [id]);

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('name', name);
        formData.append('title', title);
        formData.append('review', review);
        formData.append('image', image);
        formData.append('status', testStatus);

        http.post(`/update-testimoniul/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                setLoader('off');
                const errors = res.data.error;
                setNameError(errors.name ? errors.name[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setReviewError(errors.review ? errors.review[0] : '');
            } else {
                setLoader('off');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setImage(selectedImage);
        setImagePreview(URL.createObjectURL(selectedImage));
    };

    return (
        <div className="main-content">
            <section className="section userr">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <h5>Edit Testimonial</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row">
                                        {/* Image Section */}
                                        <div className="col-md-4 text-center">
                                            <label htmlFor="userImage">
                                                <div className="image-box border dottet p-2 rounded mx-auto" style={{ width: '250px', height: '250px', overflow: 'hidden' }}>
                                                    {imagePreview ? (
                                                        <img src={imagePreview} className="img-fluid" alt="Preview" />
                                                    ) : (
                                                        <img src="https://www.shareicon.net/data/512x512/2016/05/24/770137_man_512x512.png" className="img-fluid" alt="Default" />
                                                    )}
                                                </div>
                                                <input type="file" id="userImage" className="form-control d-none" onChange={handleImageChange} />
                                                <span className="btn btn-primary mt-2 w-100">Upload Image</span>
                                            </label>
                                        </div>

                                        {/* Form Section */}
                                        <div className="col-md-8">
                                            <div className="form-group mb-3">
                                                <label>Name</label>
                                                <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                                                <span className="text-danger">{nameError}</span>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Title</label>
                                                <input type="text" className="form-control" value={title} onChange={e => setTitle(e.target.value)} />
                                                <span className="text-danger">{titleError}</span>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Status</label>
                                                <select className="form-control" value={testStatus} onChange={e => setTestStatus(e.target.value)}>
                                                    <option value="" disabled>Select</option>
                                                    <option value="1">Active</option>
                                                    <option value="0">De-Active</option>
                                                </select>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Review</label>
                                                <textarea className="form-control" rows="5" value={review} onChange={e => setReview(e.target.value)}></textarea>
                                                <span className="text-danger">{reviewError}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-center mt-4">
                                        {loader === 'off' ? (
                                            <button type="submit" onClick={submitForm} className="btn btn-primary btn-lg">Update</button>
                                        ) : (
                                            <div className="spinner-border text-dark" role="status"></div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TestimoniulEdit;
